import { DigitalVisitReasonEnum } from "@/lib/__generated/api";

export const CACHE_CONTROL_NO_CACHE = "no-cache, max-age=0, must-revalidate";

export const SENTRY_DSN =
  "https://436057ab8329121dd006a736185abff9@o4508615315554304.ingest.us.sentry.io/4511309470433280";

export const FALLBACK_FACILITY_PHONE_NUMBER = "8002773633";
export const BRAND_NAME = "ASPEN_DENTAL";

// Form event question names for the SMS consent checkboxes. The client sends them and the
// /api/formEvents proxy matches on them to attach the environment's OneTrust purpose ids.
export const SMS_CONSENT_QUESTIONS = {
  marketing: "sms_marketing",
  transactional: "sms_transactional",
} as const;

// Values of the `variant` variable on the VWO `smsConsent` feature.
export const SMS_CONSENT_VARIANTS = ["control", "hidden"] as const;
export type SmsConsentVariant = (typeof SMS_CONSENT_VARIANTS)[number];

export const TERMS_OF_USE_URL = "https://www.aspendental.com/terms-of-use";
export const PRIVACY_POLICY_URL = "https://www.aspendental.com/privacy-policy";

export const LOCAL_STORAGE_KEYS = {
  FACILITY_CODE: "facilityCode",
} as const;

export const VISIT_REASON_PATHS: Partial<Record<DigitalVisitReasonEnum, string[]>> = {
  [DigitalVisitReasonEnum.Emergency]: ["emergency"],
  [DigitalVisitReasonEnum.Dentures]: ["dentures"],
  [DigitalVisitReasonEnum.BrokenToothToothPain]: ["brokentooth-toothpain"],
  [DigitalVisitReasonEnum.ClearAligners]: ["mottoaligners"],
  [DigitalVisitReasonEnum.Implants]: ["implants"],
  [DigitalVisitReasonEnum.Other]: ["other"],
  [DigitalVisitReasonEnum.HealthyMouthMovement]: ["dayofservice"],
};
